import nav from "./modules/Nav";
import inpageNav from "./modules/inpage-nav";

// inpage-nav
inpageNav.init();
//Header Navigation
nav.init();
